// Copyright (c) Proto Labs, Inc. All Rights Reserved.
// Borrowed from https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript
export class ErrorUtility {
    getErrorMessage(error) {
        return this.toErrorWithMessage(error).message;
    }
    isErrorWithMessage(error) {
        return (typeof error === 'object' &&
            error !== null &&
            'message' in error &&
            typeof error.message === 'string');
    }
    toErrorWithMessage(maybeError) {
        if (this.isErrorWithMessage(maybeError)) {
            return maybeError;
        }
        try {
            return new Error(JSON.stringify(maybeError));
        }
        catch {
            // fallback in case there's an error stringifying the maybeError
            // like with circular references for example.
            return new Error(String(maybeError));
        }
    }
}
//# sourceMappingURL=ErrorUtility.js.map